module.exports = __webpack_public_path__ + "assets/close-black-081d6c26f5fdaea48da879c77af6b6ee.svg";